export const ProfileTab = {
  Statistics: 'statistics',
  Coins: 'coins',
  Followers: 'followers',
  Following: 'following',
  Referral: 'referral',
  Transactions: 'transactions',
  Comments: 'comments',
} as const

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ProfileTab = (typeof ProfileTab)[keyof typeof ProfileTab]
export const ProfileTabs: Array<ProfileTab> = [
  ProfileTab.Statistics,
  // ProfileTab.Coins,
  ProfileTab.Followers,
  ProfileTab.Following,
  ProfileTab.Referral,
  ProfileTab.Transactions,
  ProfileTab.Comments,
]
